import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import SEOHead from '@/components/common/SEOHead';
import { AlertTriangle, Home, ArrowLeft } from 'lucide-react';

export default function NotFoundPage() {
  const { currentLang } = useLanguage();
  const lang = currentLang || 'tr';

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="not-found-page">
      <SEOHead title="404 - Sayfa Bulunamadi | ODDSIS" description="Aradiginiz sayfa bulunamadi." />
      <div className="text-center max-w-md">
        <AlertTriangle className="w-16 h-16 text-amber-500 mx-auto mb-6" />
        <h1 className="text-6xl font-black text-white mb-4" style={{ fontFamily: 'var(--font-heading)' }}>404</h1>
        <p className="text-lg text-slate-300 mb-2">
          {lang === 'tr' ? 'Sayfa Bulunamadi' : 'Page Not Found'}
        </p>
        <p className="text-sm text-slate-500 mb-8">
          {lang === 'tr' ? 'Aradiginiz sayfa mevcut degil veya kaldirilmis olabilir.' : 'The page you are looking for does not exist or may have been removed.'}
        </p>
        <div className="flex items-center justify-center gap-4">
          <Link to={`/${lang}`} className="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-500 text-white px-6 py-3 rounded-xl font-semibold transition-colors">
            <Home className="w-4 h-4" />
            {lang === 'tr' ? 'Ana Sayfa' : 'Homepage'}
          </Link>
          <button onClick={() => window.history.back()} className="flex items-center gap-2 bg-slate-800 hover:bg-slate-700 text-slate-300 px-6 py-3 rounded-xl font-semibold transition-colors">
            <ArrowLeft className="w-4 h-4" />
            {lang === 'tr' ? 'Geri Don' : 'Go Back'}
          </button>
        </div>
      </div>
    </div>
  );
}
